import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card/hover-card";
import Info from "@/components/ui/icon/info";

export const DailyItemHoverDangerCard = () => {
	return (
		<HoverCard>
			<HoverCardTrigger className="absolute right-1 top-1 z-20">
				<Info className="text-error-600" size="sm" />
			</HoverCardTrigger>

			<HoverCardContent side={"bottom"} align={"center"} sideOffset={8} className="z-50 w-96">
				<div className="text-left">
					<div className="space-y-4">
						<div>
							<p>商品編集ページの設定によって、販売されていません。</p>
							<p className="text-sm">※予約の開始可能日時、予約の締切日時、翌朝のオプションなど</p>
						</div>
						<p>販売開始するには、「商品管理/各商品編集ページ」で該当する設定を変更してください。</p>
					</div>
				</div>
			</HoverCardContent>
		</HoverCard>
	);
};
